import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SettingsQuery = { settings: { enableSearch: boolean, enableFavorite?: boolean | null, enableContentTranslation: boolean, enableAI: boolean, trackPublishedDocuments?: boolean | null, hierarchiesPageRoles?: Array<string> | null, jobList?: Array<string> | null, jsonataDependenciesEnabled?: boolean | null, enableExternalCallLog?: boolean | null, enableUserAnalytics?: boolean | null, enableFindReplace?: boolean | null, enableBulkChangeRules?: boolean | null, enableInheritFromParent?: boolean | null, enableLinkTo?: boolean | null, variantPricingEnabled?: boolean | null, publishedContentSourceEnabled?: boolean | null, enableSearchCellEditing?: boolean | null, hasFieldEncryptionKey?: boolean | null, hiddenNodeActions?: any | null, nodeActionsPlacement?: any | null, appBar?: any | null, createHierarchyRoles?: Array<string> | null, favoriteRoles?: { configurableProducts?: Array<string> | null, nonConfigurableProducts?: Array<string> | null, productFamilies?: Array<string> | null, default?: Array<string> | null } | null, theme?: { primaryColor?: string | null, secondaryColor?: string | null, logo?: string | null, bgColor?: string | null, sidebarWidth?: string | null, fontFamily?: string | null } | null, prototype?: { enable: boolean, hideCreatePrototype?: boolean | null, filterContentTypeGroup?: string | null, modelSelectionLayout?: string | null, modelSelectionSidebarWidth?: string | null, fallbackCurrency?: string | null, optionFilters?: { enable?: boolean | null } | null, contentTypes: { prototypeOptions?: { contentTypeGroup: string, contentType: string } | null, modelName?: { contentTypeGroup: string, contentType: string } | null, modelImage?: { contentTypeGroup: string, contentType: string } | null, itemType?: { contentTypeGroup: string, contentType: string } | null, modelOptions: Array<{ contentTypeGroup: string, contentType: string }>, optionPrice?: { contentTypeGroup: string, contentType: string } | null, optionCost?: { contentTypeGroup: string, contentType: string } | null, optionWarning?: { contentTypeGroup: string, contentType: string, warningMessage: string } | null, configuratorType?: { contentTypeGroup: string, contentType: string } | null, configuratorBaseUrl?: { contentTypeGroup: string, contentType: string } | null, configuratorApiKey?: { contentTypeGroup: string, contentType: string } | null, configuratorPackagePath?: { contentTypeGroup: string, contentType: string } | null, configuratorViewId?: { contentTypeGroup: string, contentType: string } | null, phasedIn?: { contentTypeGroup: string, contentType: string } | null, phasedOut?: { contentTypeGroup: string, contentType: string } | null, replacedBy?: { contentTypeGroup: string, contentType: string } | null }, hierarchies?: { model: string, prototype: string, modelSelection?: string | null, configurationRules?: string | null, prototypeCompatibilities?: string | null } | null, defaultColumns?: Array<{ contentTypeGroup: string, contentType: string }> | null, phaseOut?: { soonLabelEnabled?: boolean | null, soonLabelDays?: number | null } | null } | null, pimPricing?: { enable: boolean, hierarchies: { priceLists: string } } | null, cpq?: { enable: boolean, enableCart?: boolean | null, enableOrders?: boolean | null, enableFindSimilar?: boolean | null, enableAddLinkedProduct?: boolean | null, enableAddTemporaryFeature?: boolean | null, enableAddTemporaryWarranty?: boolean | null, enableAdditionalInfo?: boolean | null, disableCompatiblePromptAfterFinalize?: boolean | null, defaultTaxRate?: number | null, defaultValidityDays?: number | null, currency?: string | null, lineItemPricingContentTypeGroups?: Array<string> | null, offerInfoContentTypeGroups?: Array<string> | null, readonlyStatuses?: Array<string> | null, hierarchies: { offers: string, lineItems: string, sections: string, templates?: string | null, orders?: string | null, orderLineItems?: string | null }, offerNumberFormat?: { prefix: string, includeYear: boolean, sequenceLength: number } | null, orderNumberFormat?: { prefix: string, includeYear: boolean, sequenceLength: number } | null, configurator?: { drawerWidth?: string | null, sidebarWidth?: string | null, recapWidth?: number | null, defaultGroupsExpanded?: boolean | null, defaultRecapFeaturesExpanded?: boolean | null, defaultRecapExpanded?: boolean | null } | null, discountLimits?: { maxPercentage: number, roleOverrides?: Array<{ role: string, maxPercentage: number }> | null } | null, workflowStatusContentType?: { contentTypeGroup: string, contentType: string } | null, orderWorkflowStatusContentType?: { contentTypeGroup: string, contentType: string } | null, lineItemColumns?: Array<{ contentTypeGroup: string, contentType: string }> | null, support?: { requestStatus?: string | null, offer: { request: { contentTypeGroup: string, contentType: string }, response: { contentTypeGroup: string, contentType: string } }, lineItem: { request: { contentTypeGroup: string, contentType: string }, response: { contentTypeGroup: string, contentType: string } } } | null, offerList?: { systemColumns?: Array<string> | null, linkedByObjectSchemas?: Array<string> | null, enableExport?: boolean | null, columns?: Array<{ contentTypeGroup: string, contentType: string }> | null } | null, orderList?: { systemColumns?: Array<string> | null, linkedByObjectSchemas?: Array<string> | null, enableExport?: boolean | null, columns?: Array<{ contentTypeGroup: string, contentType: string }> | null } | null, chainedConfiguration?: { enable: boolean, productSelectorFeatureCode: string, optionMappingsHierarchyId: string, productIdMapping?: Array<{ optionValue: string, productId: string }> | null } | null } | null, crm?: { enable: boolean, staleLeadDays?: number | null, hierarchies: { leads?: string | null, accounts?: string | null, contacts?: string | null, opportunities?: string | null, activities?: string | null }, pipeline: { stages: Array<{ code: string, label: string, probability: number, order: number }> }, workflowStatusContentType?: { contentTypeGroup: string, contentType: string } | null } | null, cadPreview?: { enabled: boolean, type: string } | null, searchDataPagination?: { pageSizes: Array<number>, defaultPageSize: number } | null, cgtSettings?: { disableCreateFromHierarchy?: Array<string> | null, disableChangeParentHierarchy?: Array<string> | null, enableReplaceLinkHierarchy?: Array<string> | null, pricelistCatNodeCode: string, listiniPerZMABCode: string, manodoperaSupplierId: string, useDynamicRules?: boolean | null, enableAutoPriceAlignment?: boolean | null, skipCertificate: boolean, skipPublish: boolean, skipExport: boolean, skipStatus: boolean, skipHinto: boolean, forceCertificateButtonActive: boolean, showNodeStatuses: boolean, coolsalesExporter: { couch: { dbUri: string, dbName: string } }, exporter: { couch: { dbUri: string, dbName: string }, sql: { host: string, user: string, password: string, database: string } }, prototypeSetting: { prototypeHierarchyId: string, objectSchemaCode: string, modelCode: string, glCodes: Array<string>, certificationStatuses: { certified: string, draft: string, certifiedDraft: string, inCertification: string, certifiedInCertification: string, error: string, certifiedError: string, certifiedPublished: string }, priceCodes: { dn: { key: string, value?: string | null }, dnWithDelta: { key: string, value?: string | null }, dn_cash_d: { key: string, value?: string | null }, tpa: { key: string, value?: string | null }, gp: { key: string, value?: string | null }, list_price: { key: string, value?: string | null }, lc: { key: string, value?: string | null }, gl_list_price: { key: string, value?: string | null }, gl_tpa: { key: string, value?: string | null }, transport_costs: { key: string, value?: string | null }, standard_price_delta: { key: string }, ms: { key: string, value?: string | null }, gp_ms: { key: string }, gp_tpa: { key: string }, mo: { key: string, value?: string | null }, markup: { key: string }, dealer_ms: { key: string, value?: string | null }, dealer_price: { key: string, value?: string | null }, dealer_gp: { key: string, value?: string | null }, forced_tpa: { key: string, value?: string | null }, forced_gp: { key: string, value?: string | null }, forced_vn: { key: string, value?: string | null }, forced_dealer_gp: { key: string, value?: string | null }, forced_dealer_price: { key: string, value?: string | null }, extra_discount: { key: string, value?: string | null } } }, hierarchies: { priceListHierarchyId: string, supplierHierarchyId: string, glHierarchyId: string, cGTModelHierarchyId: string, cGTModelUsatoCompetitorHierarchyId: string, glGenericHierarchyId: string, attrezzatureFuoriListinoHierarchyId: string, plantHierarchyId?: string | null, glUsatoCompetitorHierarchyId: string, glExFlottaHierarchyId: string, mediaHierarchyId: string, sapProductHierarchyId: string, sapProductCompetitorHierarchyId: string, marcheHierarchyId: string, shortListsHierarchyId: string, longListsHierarchyId: string, commercialFamilyHierarchyId: string, shortListFamilyHierarchyId: string, sezioniSchedeHierarchyId: string, linkedGlsCompatibilityRulesHierarchyId: string, characteristicsCompatibilityRulesHierarchyId: string, usagesCompatibilityRulesHierarchyId: string, prototypeCompatibilitiesHierarchyId: string, shortListFamiliesExtraCharacteristicsHierarchyId: string, systemSubSystemHierarchyId: string, warrantySupplierHierarchyId: string, warrantyCgtHierarchyId: string, digitalServiceHierarchyId: string, serviceModuleHierarchyId: string, serviceContractHierarchyId: string, serviceModuleKmListHierarchyId: string, serviceModuleAMAListHierarchyId: string, serviceModuleKitListHierarchyId: string, tagliandiHierarchyId?: string | null, ricambiHierarchyId?: string | null, productWarrantyHierarchyId: string, applicationCodeHierarchyId: string, cadenzaInterventoHierarchyId: string, mmDispoHierarchyId: string, backofficeHierarchyId?: string | null }, objectSchemas: { sapProductHierarchyObjectSchemaId: string, glHierarchyObjectSchemaId: string, shortListFamiliesExtraCharacteristicsObjectSchemaId: string, longListsHierarchyObjectSchemaId: string, cgtModelHierarchyObjectSchemaId: string, prototypeHierarchyObjectSchemaId: string }, fields: { nodeTypeField: { contentTypeCode: string, defaultValue?: string | null }, orderTypeField: { contentTypeCode: string }, lineaSapField: { contentTypeCode: string }, marcaField: { contentTypeCode: string }, sapProductHierarchyField: { contentTypeCode: string }, biasedField: { contentTypeCode: string }, extraValueSupportField: { contentTypeCode: string }, incentiveVolumeField: { contentTypeCode: string }, supplierField: { contentTypeCode: string }, descriptionField: { contentTypeCode: string }, suffixField: { contentTypeCode: string }, supplierNameField: { contentTypeCode: string }, priceListField: { contentTypeCode: string }, typeField: { contentTypeCode: string, defaultValue?: string | null }, itemsField: { contentTypeCode: string }, c1Field: { contentTypeCode: string }, c2Field: { contentTypeCode: string }, c3Field: { contentTypeCode: string }, lcField: { contentTypeCode: string }, baseProgramField: { contentTypeCode: string }, svField: { contentTypeCode: string }, cvaField: { contentTypeCode: string }, conquestField: { contentTypeCode: string }, dealerDiscountField: { contentTypeCode: string }, certificationStatusField: { contentTypeCode: string }, installedDealerNetField: { contentTypeCode: string }, notInstalledDealerNetField: { contentTypeCode: string }, cashDiscountField: { contentTypeCode: string }, glBaseMachineField: { contentTypeCode: string }, denominationField: { contentTypeCode: string }, familyField: { contentTypeCode: string }, modelCodeField: { contentTypeCode: string }, selectionsField: { contentTypeCode: string }, flagUseDN: { contentTypeCode: string }, segmento: { contentTypeCode: string }, tipo: { contentTypeCode: string }, marca: { contentTypeCode: string }, divisione: { contentTypeCode: string } }, groups: { pricingGroup: { contentTypeGroupCode: string }, catSupportGroup: { contentTypeGroupCode: string }, cgtSupportGroup: { contentTypeGroupCode: string }, sapCharacteristicsGroup: { contentTypeGroupCode: string } }, paths: { accessories: string, baseMachine: string, priceListValue: string, primaryPriceListValue: string, secondaryPriceListValue: string, itemsValue: string, sapProductHierarchyValue: string }, discountMPRoles: Array<{ role: string, min: string, max: string }> } | null, customPages?: Array<{ id: string, name: string, slug: string, hierarchyId: string, objectSchemaCode?: string | null, icon?: string | null, requiredRole?: string | null, hideInNavbar?: boolean | null, fullBleed?: boolean | null, detailLayoutFrom?: string | null, filter?: { contentTypeGroup: string, contentType: string, comparator: string, value: string } | null, listLayout: { columns: Array<{ width?: string | null, keepWidgetSlots?: boolean | null, widgets: Array<{ type: string, config?: { overtextContentTypeCode?: string | null, fileDisplay?: string | null, dense?: boolean | null, viewMode?: string | null, maxItems?: number | null, icon?: string | null, title?: string | null, showIcon?: boolean | null, showLabel?: boolean | null, showSeparator?: boolean | null, displayContentTypes?: Array<string> | null, contentTypeGroups?: Array<string> | null, hideTopBar?: boolean | null, hideCode?: boolean | null, hideBackButton?: boolean | null, hideBottomBar?: boolean | null, hideContentTypeGroupHeaders?: boolean | null, showAddButton?: boolean | null, imageContentType?: any | null, cardVariant?: string | null, showSearch?: boolean | null, direction?: string | null, cardWidth?: string | null, cardHeight?: string | null, rowGap?: string | null, stretchCards?: boolean | null, columnGap?: string | null, cardBgColor?: string | null, cardTextColor?: string | null, mergeTitle?: boolean | null, typeContentType?: string | null, loadMore?: boolean | null, showNewButton?: boolean | null, autoOpenSingleResult?: boolean | null, linkContentTypeCode?: string | null, linkPath?: Array<string> | null, linkedByHierarchyId?: string | null, hierarchyId?: string | null, hierarchyIds?: Array<string> | null, displayMode?: string | null, fullWidth?: boolean | null, showHeading?: boolean | null, backButtonLabel?: string | null, backLink?: string | null, headingContentTypeCode?: string | null, position?: string | null, sticky?: boolean | null, roles?: Array<string> | null, width?: number | null, bgColor?: string | null, textColor?: string | null, maxHeight?: string | null, showViewAll?: boolean | null, backgroundColor?: string | null, showTitle?: boolean | null, titleContentTypeCode?: string | null, titleStyle?: string | null, chartType?: string | null, colorScheme?: string | null, legendPosition?: string | null, cellIcon?: string | null, exportEnabled?: boolean | null, linkDepth?: number | null, contentSource?: string | null, text?: string | null, columnsPerRow?: number | null, rootNodeId?: string | null, languages?: Array<string> | null, channelCodes?: Array<string> | null, channelCode?: string | null, pageSize?: number | null, eventType?: string | null, limit?: number | null, periodDays?: number | null, bucket?: string | null, infoItems?: Array<{ contentTypeCode: string, label?: string | null, icon?: string | null }> | null, numberFormats?: Array<{ contentTypeCode: string, style?: string | null, currency?: string | null, minimumFractionDigits?: number | null, maximumFractionDigits?: number | null, useGrouping?: boolean | null }> | null, imageStyle?: { width?: string | null, height?: string | null, maxWidth?: string | null, maxHeight?: string | null, objectFit?: string | null, borderRadius?: string | null } | null, sort?: { field: string, order?: string | null } | null, actions?: Array<{ type: string, contentTypeGroups?: Array<string> | null, iconOnly?: boolean | null, templateIds?: Array<string> | null }> | null, itemAction?: { type: string } | null, detailPage?: { slug: string, linkContentType?: string | null } | null, margin?: { x?: number | null, y?: number | null, t?: number | null, b?: number | null, l?: number | null, r?: number | null } | null, padding?: { x?: number | null, y?: number | null, t?: number | null, b?: number | null, l?: number | null, r?: number | null } | null, dimensionContentType?: { contentTypeGroup: string, contentType: string } | null, measureContentType?: { contentTypeGroup: string, contentType: string } | null, chartFilters?: Array<{ field: string, operator: string, value: Array<string> }> | null, clickAction?: { type: string, path?: string | null } | null, rows?: { hierarchyId?: string | null, label?: string | null, depthRange?: Array<number> | null, includeDisabled?: boolean | null, labelProperty?: string | null } | null, columns?: { hierarchyId?: string | null, label?: string | null, depthRange?: Array<number> | null, includeDisabled?: boolean | null, labelProperty?: string | null } | null, cards?: Array<{ title: string, icon?: string | null, image?: string | null, link?: string | null, openInNewTab?: boolean | null, bgColor?: string | null, textColor?: string | null }> | null, buttons?: Array<{ label: string, link: string, openInNewTab?: boolean | null, variant?: string | null, color?: string | null, fullWidth?: boolean | null }> | null, countedFields?: Array<{ contentTypeGroup: string, contentType: string }> | null } | null }>, tabs?: Array<{ id: string, label: string, icon?: string | null, widgets: Array<{ type: string, config?: { overtextContentTypeCode?: string | null, fileDisplay?: string | null, dense?: boolean | null, viewMode?: string | null, maxItems?: number | null, icon?: string | null, title?: string | null, showIcon?: boolean | null, showLabel?: boolean | null, showSeparator?: boolean | null, displayContentTypes?: Array<string> | null, contentTypeGroups?: Array<string> | null, hideTopBar?: boolean | null, hideCode?: boolean | null, hideBackButton?: boolean | null, hideBottomBar?: boolean | null, hideContentTypeGroupHeaders?: boolean | null, showAddButton?: boolean | null, imageContentType?: any | null, cardVariant?: string | null, showSearch?: boolean | null, direction?: string | null, cardWidth?: string | null, cardHeight?: string | null, rowGap?: string | null, stretchCards?: boolean | null, columnGap?: string | null, cardBgColor?: string | null, cardTextColor?: string | null, mergeTitle?: boolean | null, typeContentType?: string | null, loadMore?: boolean | null, showNewButton?: boolean | null, autoOpenSingleResult?: boolean | null, linkContentTypeCode?: string | null, linkPath?: Array<string> | null, linkedByHierarchyId?: string | null, hierarchyId?: string | null, hierarchyIds?: Array<string> | null, displayMode?: string | null, fullWidth?: boolean | null, showHeading?: boolean | null, backButtonLabel?: string | null, backLink?: string | null, headingContentTypeCode?: string | null, position?: string | null, sticky?: boolean | null, roles?: Array<string> | null, width?: number | null, bgColor?: string | null, textColor?: string | null, maxHeight?: string | null, showViewAll?: boolean | null, backgroundColor?: string | null, showTitle?: boolean | null, titleContentTypeCode?: string | null, titleStyle?: string | null, chartType?: string | null, colorScheme?: string | null, legendPosition?: string | null, cellIcon?: string | null, exportEnabled?: boolean | null, linkDepth?: number | null, contentSource?: string | null, text?: string | null, columnsPerRow?: number | null, rootNodeId?: string | null, languages?: Array<string> | null, channelCodes?: Array<string> | null, channelCode?: string | null, pageSize?: number | null, infoItems?: Array<{ contentTypeCode: string, label?: string | null, icon?: string | null }> | null, numberFormats?: Array<{ contentTypeCode: string, style?: string | null, currency?: string | null, minimumFractionDigits?: number | null, maximumFractionDigits?: number | null, useGrouping?: boolean | null }> | null, imageStyle?: { width?: string | null, height?: string | null, maxWidth?: string | null, maxHeight?: string | null, objectFit?: string | null, borderRadius?: string | null } | null, sort?: { field: string, order?: string | null } | null, actions?: Array<{ type: string, contentTypeGroups?: Array<string> | null, iconOnly?: boolean | null, templateIds?: Array<string> | null }> | null, itemAction?: { type: string } | null, detailPage?: { slug: string, linkContentType?: string | null } | null, margin?: { x?: number | null, y?: number | null, t?: number | null, b?: number | null, l?: number | null, r?: number | null } | null, padding?: { x?: number | null, y?: number | null, t?: number | null, b?: number | null, l?: number | null, r?: number | null } | null, dimensionContentType?: { contentTypeGroup: string, contentType: string } | null, measureContentType?: { contentTypeGroup: string, contentType: string } | null, chartFilters?: Array<{ field: string, operator: string, value: Array<string> }> | null, clickAction?: { type: string, path?: string | null } | null, rows?: { hierarchyId?: string | null, label?: string | null, depthRange?: Array<number> | null, includeDisabled?: boolean | null, labelProperty?: string | null } | null, columns?: { hierarchyId?: string | null, label?: string | null, depthRange?: Array<number> | null, includeDisabled?: boolean | null, labelProperty?: string | null } | null, cards?: Array<{ title: string, icon?: string | null, image?: string | null, link?: string | null, openInNewTab?: boolean | null, bgColor?: string | null, textColor?: string | null }> | null, buttons?: Array<{ label: string, link: string, openInNewTab?: boolean | null, variant?: string | null, color?: string | null, fullWidth?: boolean | null }> | null, countedFields?: Array<{ contentTypeGroup: string, contentType: string }> | null } | null }> }> | null }> }, detailLayout: { columns: Array<{ width?: string | null, keepWidgetSlots?: boolean | null, widgets: Array<{ type: string, config?: { overtextContentTypeCode?: string | null, fileDisplay?: string | null, dense?: boolean | null, viewMode?: string | null, maxItems?: number | null, icon?: string | null, title?: string | null, showIcon?: boolean | null, showLabel?: boolean | null, showSeparator?: boolean | null, displayContentTypes?: Array<string> | null, contentTypeGroups?: Array<string> | null, hideTopBar?: boolean | null, hideCode?: boolean | null, hideBackButton?: boolean | null, hideBottomBar?: boolean | null, hideContentTypeGroupHeaders?: boolean | null, showAddButton?: boolean | null, imageContentType?: any | null, cardVariant?: string | null, showSearch?: boolean | null, direction?: string | null, cardWidth?: string | null, cardHeight?: string | null, rowGap?: string | null, stretchCards?: boolean | null, columnGap?: string | null, cardBgColor?: string | null, cardTextColor?: string | null, mergeTitle?: boolean | null, typeContentType?: string | null, loadMore?: boolean | null, showNewButton?: boolean | null, autoOpenSingleResult?: boolean | null, linkContentTypeCode?: string | null, linkPath?: Array<string> | null, linkedByHierarchyId?: string | null, hierarchyId?: string | null, hierarchyIds?: Array<string> | null, displayMode?: string | null, fullWidth?: boolean | null, showHeading?: boolean | null, backButtonLabel?: string | null, backLink?: string | null, headingContentTypeCode?: string | null, position?: string | null, sticky?: boolean | null, roles?: Array<string> | null, width?: number | null, bgColor?: string | null, textColor?: string | null, maxHeight?: string | null, showViewAll?: boolean | null, backgroundColor?: string | null, showTitle?: boolean | null, titleContentTypeCode?: string | null, titleStyle?: string | null, chartType?: string | null, colorScheme?: string | null, legendPosition?: string | null, cellIcon?: string | null, exportEnabled?: boolean | null, linkDepth?: number | null, contentSource?: string | null, text?: string | null, columnsPerRow?: number | null, rootNodeId?: string | null, languages?: Array<string> | null, channelCodes?: Array<string> | null, channelCode?: string | null, pageSize?: number | null, eventType?: string | null, limit?: number | null, periodDays?: number | null, bucket?: string | null, infoItems?: Array<{ contentTypeCode: string, label?: string | null, icon?: string | null }> | null, numberFormats?: Array<{ contentTypeCode: string, style?: string | null, currency?: string | null, minimumFractionDigits?: number | null, maximumFractionDigits?: number | null, useGrouping?: boolean | null }> | null, imageStyle?: { width?: string | null, height?: string | null, maxWidth?: string | null, maxHeight?: string | null, objectFit?: string | null, borderRadius?: string | null } | null, sort?: { field: string, order?: string | null } | null, actions?: Array<{ type: string, contentTypeGroups?: Array<string> | null, iconOnly?: boolean | null, templateIds?: Array<string> | null }> | null, itemAction?: { type: string } | null, detailPage?: { slug: string, linkContentType?: string | null } | null, margin?: { x?: number | null, y?: number | null, t?: number | null, b?: number | null, l?: number | null, r?: number | null } | null, padding?: { x?: number | null, y?: number | null, t?: number | null, b?: number | null, l?: number | null, r?: number | null } | null, dimensionContentType?: { contentTypeGroup: string, contentType: string } | null, measureContentType?: { contentTypeGroup: string, contentType: string } | null, chartFilters?: Array<{ field: string, operator: string, value: Array<string> }> | null, clickAction?: { type: string, path?: string | null } | null, rows?: { hierarchyId?: string | null, label?: string | null, depthRange?: Array<number> | null, includeDisabled?: boolean | null, labelProperty?: string | null } | null, columns?: { hierarchyId?: string | null, label?: string | null, depthRange?: Array<number> | null, includeDisabled?: boolean | null, labelProperty?: string | null } | null, cards?: Array<{ title: string, icon?: string | null, image?: string | null, link?: string | null, openInNewTab?: boolean | null, bgColor?: string | null, textColor?: string | null }> | null, buttons?: Array<{ label: string, link: string, openInNewTab?: boolean | null, variant?: string | null, color?: string | null, fullWidth?: boolean | null }> | null, countedFields?: Array<{ contentTypeGroup: string, contentType: string }> | null } | null }>, tabs?: Array<{ id: string, label: string, icon?: string | null, widgets: Array<{ type: string, config?: { overtextContentTypeCode?: string | null, fileDisplay?: string | null, dense?: boolean | null, viewMode?: string | null, maxItems?: number | null, icon?: string | null, title?: string | null, showIcon?: boolean | null, showLabel?: boolean | null, showSeparator?: boolean | null, displayContentTypes?: Array<string> | null, contentTypeGroups?: Array<string> | null, hideTopBar?: boolean | null, hideCode?: boolean | null, hideBackButton?: boolean | null, hideBottomBar?: boolean | null, hideContentTypeGroupHeaders?: boolean | null, showAddButton?: boolean | null, imageContentType?: any | null, cardVariant?: string | null, showSearch?: boolean | null, direction?: string | null, cardWidth?: string | null, cardHeight?: string | null, rowGap?: string | null, stretchCards?: boolean | null, columnGap?: string | null, cardBgColor?: string | null, cardTextColor?: string | null, mergeTitle?: boolean | null, typeContentType?: string | null, loadMore?: boolean | null, showNewButton?: boolean | null, autoOpenSingleResult?: boolean | null, linkContentTypeCode?: string | null, linkPath?: Array<string> | null, linkedByHierarchyId?: string | null, hierarchyId?: string | null, hierarchyIds?: Array<string> | null, displayMode?: string | null, fullWidth?: boolean | null, showHeading?: boolean | null, backButtonLabel?: string | null, backLink?: string | null, headingContentTypeCode?: string | null, position?: string | null, sticky?: boolean | null, roles?: Array<string> | null, width?: number | null, bgColor?: string | null, textColor?: string | null, maxHeight?: string | null, showViewAll?: boolean | null, backgroundColor?: string | null, showTitle?: boolean | null, titleContentTypeCode?: string | null, titleStyle?: string | null, chartType?: string | null, colorScheme?: string | null, legendPosition?: string | null, cellIcon?: string | null, exportEnabled?: boolean | null, linkDepth?: number | null, contentSource?: string | null, text?: string | null, columnsPerRow?: number | null, rootNodeId?: string | null, languages?: Array<string> | null, channelCodes?: Array<string> | null, channelCode?: string | null, pageSize?: number | null, infoItems?: Array<{ contentTypeCode: string, label?: string | null, icon?: string | null }> | null, numberFormats?: Array<{ contentTypeCode: string, style?: string | null, currency?: string | null, minimumFractionDigits?: number | null, maximumFractionDigits?: number | null, useGrouping?: boolean | null }> | null, imageStyle?: { width?: string | null, height?: string | null, maxWidth?: string | null, maxHeight?: string | null, objectFit?: string | null, borderRadius?: string | null } | null, sort?: { field: string, order?: string | null } | null, actions?: Array<{ type: string, contentTypeGroups?: Array<string> | null, iconOnly?: boolean | null, templateIds?: Array<string> | null }> | null, itemAction?: { type: string } | null, detailPage?: { slug: string, linkContentType?: string | null } | null, margin?: { x?: number | null, y?: number | null, t?: number | null, b?: number | null, l?: number | null, r?: number | null } | null, padding?: { x?: number | null, y?: number | null, t?: number | null, b?: number | null, l?: number | null, r?: number | null } | null, dimensionContentType?: { contentTypeGroup: string, contentType: string } | null, measureContentType?: { contentTypeGroup: string, contentType: string } | null, chartFilters?: Array<{ field: string, operator: string, value: Array<string> }> | null, clickAction?: { type: string, path?: string | null } | null, rows?: { hierarchyId?: string | null, label?: string | null, depthRange?: Array<number> | null, includeDisabled?: boolean | null, labelProperty?: string | null } | null, columns?: { hierarchyId?: string | null, label?: string | null, depthRange?: Array<number> | null, includeDisabled?: boolean | null, labelProperty?: string | null } | null, cards?: Array<{ title: string, icon?: string | null, image?: string | null, link?: string | null, openInNewTab?: boolean | null, bgColor?: string | null, textColor?: string | null }> | null, buttons?: Array<{ label: string, link: string, openInNewTab?: boolean | null, variant?: string | null, color?: string | null, fullWidth?: boolean | null }> | null, countedFields?: Array<{ contentTypeGroup: string, contentType: string }> | null } | null }> }> | null }> } }> | null, defaultPageUri?: { uri: string, roleOverrides?: Array<{ role: string, uri: string }> | null } | null, fiammSettings?: { balanceGoalsHierarchyId: string, pattuizioniHierarchyId?: string | null } | null, globalSearch?: { hierarchyIds: Array<string>, resultsPerGroup: number, showPhasedOut?: boolean | null, groupLabels?: Array<{ hierarchyId: string, label: string }> | null } | null, userManagement?: { hierarchyId: string, dealershipHierarchyId?: string | null } | null, media?: { enable?: boolean | null, hierarchyId: string } | null, channels?: Array<{ code: string, label?: any | null, locales: Array<string>, schemaCodes?: Array<string> | null }> | null } };


export const SettingsDocument = gql`
    query Settings {
  settings {
    enableSearch
    enableFavorite
    favoriteRoles {
      configurableProducts
      nonConfigurableProducts
      productFamilies
      default
    }
    enableContentTranslation
    enableAI
    theme {
      primaryColor
      secondaryColor
      logo
      bgColor
      sidebarWidth
      fontFamily
    }
    prototype {
      enable
      hideCreatePrototype
      filterContentTypeGroup
      modelSelectionLayout
      modelSelectionSidebarWidth
      optionFilters {
        enable
      }
      contentTypes {
        prototypeOptions {
          contentTypeGroup
          contentType
        }
        modelName {
          contentTypeGroup
          contentType
        }
        modelImage {
          contentTypeGroup
          contentType
        }
        itemType {
          contentTypeGroup
          contentType
        }
        modelOptions {
          contentTypeGroup
          contentType
        }
        optionPrice {
          contentTypeGroup
          contentType
        }
        optionCost {
          contentTypeGroup
          contentType
        }
        optionWarning {
          contentTypeGroup
          contentType
          warningMessage
        }
        configuratorType {
          contentTypeGroup
          contentType
        }
        configuratorBaseUrl {
          contentTypeGroup
          contentType
        }
        configuratorApiKey {
          contentTypeGroup
          contentType
        }
        configuratorPackagePath {
          contentTypeGroup
          contentType
        }
        configuratorViewId {
          contentTypeGroup
          contentType
        }
        phasedIn {
          contentTypeGroup
          contentType
        }
        phasedOut {
          contentTypeGroup
          contentType
        }
        replacedBy {
          contentTypeGroup
          contentType
        }
      }
      hierarchies {
        model
        prototype
        modelSelection
        configurationRules
        prototypeCompatibilities
      }
      defaultColumns {
        contentTypeGroup
        contentType
      }
      fallbackCurrency
      phaseOut {
        soonLabelEnabled
        soonLabelDays
      }
    }
    pimPricing {
      enable
      hierarchies {
        priceLists
      }
    }
    cpq {
      enable
      enableCart
      enableOrders
      enableFindSimilar
      enableAddLinkedProduct
      enableAddTemporaryFeature
      enableAddTemporaryWarranty
      enableAdditionalInfo
      disableCompatiblePromptAfterFinalize
      hierarchies {
        offers
        lineItems
        sections
        templates
        orders
        orderLineItems
      }
      offerNumberFormat {
        prefix
        includeYear
        sequenceLength
      }
      orderNumberFormat {
        prefix
        includeYear
        sequenceLength
      }
      defaultTaxRate
      defaultValidityDays
      currency
      configurator {
        drawerWidth
        sidebarWidth
        recapWidth
        defaultGroupsExpanded
        defaultRecapFeaturesExpanded
        defaultRecapExpanded
      }
      discountLimits {
        maxPercentage
        roleOverrides {
          role
          maxPercentage
        }
      }
      workflowStatusContentType {
        contentTypeGroup
        contentType
      }
      orderWorkflowStatusContentType {
        contentTypeGroup
        contentType
      }
      lineItemColumns {
        contentTypeGroup
        contentType
      }
      lineItemPricingContentTypeGroups
      offerInfoContentTypeGroups
      support {
        offer {
          request {
            contentTypeGroup
            contentType
          }
          response {
            contentTypeGroup
            contentType
          }
        }
        lineItem {
          request {
            contentTypeGroup
            contentType
          }
          response {
            contentTypeGroup
            contentType
          }
        }
        requestStatus
      }
      offerList {
        systemColumns
        columns {
          contentTypeGroup
          contentType
        }
        linkedByObjectSchemas
        enableExport
      }
      orderList {
        systemColumns
        columns {
          contentTypeGroup
          contentType
        }
        linkedByObjectSchemas
        enableExport
      }
      readonlyStatuses
      chainedConfiguration {
        enable
        productSelectorFeatureCode
        productIdMapping {
          optionValue
          productId
        }
        optionMappingsHierarchyId
      }
    }
    crm {
      enable
      hierarchies {
        leads
        accounts
        contacts
        opportunities
        activities
      }
      pipeline {
        stages {
          code
          label
          probability
          order
        }
      }
      staleLeadDays
      workflowStatusContentType {
        contentTypeGroup
        contentType
      }
    }
    cadPreview {
      enabled
      type
    }
    trackPublishedDocuments
    searchDataPagination {
      pageSizes
      defaultPageSize
    }
    cgtSettings {
      disableCreateFromHierarchy
      disableChangeParentHierarchy
      enableReplaceLinkHierarchy
      coolsalesExporter {
        couch {
          dbUri
          dbName
        }
      }
      exporter {
        couch {
          dbUri
          dbName
        }
        sql {
          host
          user
          password
          database
        }
      }
      pricelistCatNodeCode
      listiniPerZMABCode
      manodoperaSupplierId
      useDynamicRules
      enableAutoPriceAlignment
      skipCertificate
      skipPublish
      skipExport
      skipStatus
      skipHinto
      forceCertificateButtonActive
      showNodeStatuses
      prototypeSetting {
        prototypeHierarchyId
        objectSchemaCode
        modelCode
        glCodes
        certificationStatuses {
          certified
          draft
          certifiedDraft
          inCertification
          certifiedInCertification
          error
          certifiedError
          certifiedPublished
        }
        priceCodes {
          dn {
            key
            value
          }
          dnWithDelta {
            key
            value
          }
          dn_cash_d {
            key
            value
          }
          tpa {
            key
            value
          }
          gp {
            key
            value
          }
          list_price {
            key
            value
          }
          lc {
            key
            value
          }
          gl_list_price {
            key
            value
          }
          gl_tpa {
            key
            value
          }
          transport_costs {
            key
            value
          }
          standard_price_delta {
            key
          }
          ms {
            key
            value
          }
          gp_ms {
            key
          }
          gp_tpa {
            key
          }
          mo {
            key
            value
          }
          markup {
            key
          }
          dealer_ms {
            key
            value
          }
          dealer_price {
            key
            value
          }
          dealer_gp {
            key
            value
          }
          forced_tpa {
            key
            value
          }
          forced_gp {
            key
            value
          }
          forced_vn {
            key
            value
          }
          forced_dealer_gp {
            key
            value
          }
          forced_dealer_price {
            key
            value
          }
          extra_discount {
            key
            value
          }
        }
      }
      hierarchies {
        priceListHierarchyId
        supplierHierarchyId
        glHierarchyId
        cGTModelHierarchyId
        cGTModelUsatoCompetitorHierarchyId
        glGenericHierarchyId
        attrezzatureFuoriListinoHierarchyId
        plantHierarchyId
        glUsatoCompetitorHierarchyId
        glExFlottaHierarchyId
        mediaHierarchyId
        sapProductHierarchyId
        sapProductCompetitorHierarchyId
        marcheHierarchyId
        shortListsHierarchyId
        longListsHierarchyId
        commercialFamilyHierarchyId
        shortListFamilyHierarchyId
        sezioniSchedeHierarchyId
        linkedGlsCompatibilityRulesHierarchyId
        characteristicsCompatibilityRulesHierarchyId
        usagesCompatibilityRulesHierarchyId
        prototypeCompatibilitiesHierarchyId
        shortListFamiliesExtraCharacteristicsHierarchyId
        systemSubSystemHierarchyId
        warrantySupplierHierarchyId
        warrantyCgtHierarchyId
        digitalServiceHierarchyId
        serviceModuleHierarchyId
        serviceContractHierarchyId
        serviceModuleKmListHierarchyId
        serviceModuleAMAListHierarchyId
        serviceModuleKitListHierarchyId
        tagliandiHierarchyId
        ricambiHierarchyId
        productWarrantyHierarchyId
        applicationCodeHierarchyId
        cadenzaInterventoHierarchyId
        mmDispoHierarchyId
        backofficeHierarchyId
      }
      objectSchemas {
        sapProductHierarchyObjectSchemaId
        glHierarchyObjectSchemaId
        shortListFamiliesExtraCharacteristicsObjectSchemaId
        longListsHierarchyObjectSchemaId
        cgtModelHierarchyObjectSchemaId
        prototypeHierarchyObjectSchemaId
      }
      fields {
        nodeTypeField {
          contentTypeCode
          defaultValue
        }
        orderTypeField {
          contentTypeCode
        }
        lineaSapField {
          contentTypeCode
        }
        marcaField {
          contentTypeCode
        }
        sapProductHierarchyField {
          contentTypeCode
        }
        biasedField {
          contentTypeCode
        }
        extraValueSupportField {
          contentTypeCode
        }
        incentiveVolumeField {
          contentTypeCode
        }
        supplierField {
          contentTypeCode
        }
        descriptionField {
          contentTypeCode
        }
        suffixField {
          contentTypeCode
        }
        supplierNameField {
          contentTypeCode
          contentTypeCode
        }
        priceListField {
          contentTypeCode
        }
        typeField {
          contentTypeCode
          defaultValue
        }
        itemsField {
          contentTypeCode
        }
        c1Field {
          contentTypeCode
        }
        c2Field {
          contentTypeCode
        }
        c3Field {
          contentTypeCode
        }
        lcField {
          contentTypeCode
        }
        baseProgramField {
          contentTypeCode
        }
        svField {
          contentTypeCode
        }
        cvaField {
          contentTypeCode
        }
        conquestField {
          contentTypeCode
        }
        dealerDiscountField {
          contentTypeCode
        }
        certificationStatusField {
          contentTypeCode
        }
        installedDealerNetField {
          contentTypeCode
        }
        notInstalledDealerNetField {
          contentTypeCode
        }
        cashDiscountField {
          contentTypeCode
        }
        glBaseMachineField {
          contentTypeCode
        }
        denominationField {
          contentTypeCode
        }
        familyField {
          contentTypeCode
        }
        modelCodeField {
          contentTypeCode
        }
        selectionsField {
          contentTypeCode
        }
        flagUseDN {
          contentTypeCode
        }
        segmento {
          contentTypeCode
        }
        tipo {
          contentTypeCode
        }
        marca {
          contentTypeCode
        }
        divisione {
          contentTypeCode
        }
      }
      groups {
        pricingGroup {
          contentTypeGroupCode
        }
        catSupportGroup {
          contentTypeGroupCode
        }
        cgtSupportGroup {
          contentTypeGroupCode
        }
        sapCharacteristicsGroup {
          contentTypeGroupCode
        }
      }
      paths {
        accessories
        baseMachine
        priceListValue
        primaryPriceListValue
        secondaryPriceListValue
        itemsValue
        sapProductHierarchyValue
      }
      discountMPRoles {
        role
        min
        max
      }
    }
    customPages {
      id
      name
      slug
      hierarchyId
      filter {
        contentTypeGroup
        contentType
        comparator
        value
      }
      objectSchemaCode
      icon
      requiredRole
      hideInNavbar
      fullBleed
      detailLayoutFrom
      listLayout {
        columns {
          width
          keepWidgetSlots
          widgets {
            type
            config {
              infoItems {
                contentTypeCode
                label
                icon
              }
              overtextContentTypeCode
              fileDisplay
              dense
              numberFormats {
                contentTypeCode
                style
                currency
                minimumFractionDigits
                maximumFractionDigits
                useGrouping
              }
              viewMode
              maxItems
              icon
              title
              showIcon
              showLabel
              showSeparator
              imageStyle {
                width
                height
                maxWidth
                maxHeight
                objectFit
                borderRadius
              }
              displayContentTypes
              contentTypeGroups
              hideTopBar
              hideCode
              hideBackButton
              hideBottomBar
              hideContentTypeGroupHeaders
              showAddButton
              imageContentType
              cardVariant
              showSearch
              direction
              cardWidth
              cardHeight
              rowGap
              stretchCards
              columnGap
              cardBgColor
              cardTextColor
              mergeTitle
              typeContentType
              sort {
                field
                order
              }
              loadMore
              showNewButton
              autoOpenSingleResult
              linkContentTypeCode
              linkPath
              linkedByHierarchyId
              hierarchyId
              hierarchyIds
              displayMode
              fullWidth
              actions {
                type
                contentTypeGroups
                iconOnly
                templateIds
              }
              itemAction {
                type
              }
              detailPage {
                slug
                linkContentType
              }
              showHeading
              backButtonLabel
              backLink
              headingContentTypeCode
              position
              sticky
              roles
              width
              margin {
                x
                y
                t
                b
                l
                r
              }
              padding {
                x
                y
                t
                b
                l
                r
              }
              bgColor
              textColor
              maxHeight
              showViewAll
              backgroundColor
              showTitle
              titleContentTypeCode
              titleStyle
              chartType
              dimensionContentType {
                contentTypeGroup
                contentType
              }
              measureContentType {
                contentTypeGroup
                contentType
              }
              chartFilters {
                field
                operator
                value
              }
              colorScheme
              legendPosition
              clickAction {
                type
                path
              }
              cellIcon
              exportEnabled
              linkDepth
              contentSource
              rows {
                hierarchyId
                label
                depthRange
                includeDisabled
                labelProperty
              }
              columns {
                hierarchyId
                label
                depthRange
                includeDisabled
                labelProperty
              }
              cards {
                title
                icon
                image
                link
                openInNewTab
                bgColor
                textColor
              }
              text
              buttons {
                label
                link
                openInNewTab
                variant
                color
                fullWidth
              }
              columnsPerRow
              rootNodeId
              countedFields {
                contentTypeGroup
                contentType
              }
              languages
              channelCodes
              channelCode
              pageSize
              eventType
              limit
              periodDays
              bucket
            }
          }
          tabs {
            id
            label
            icon
            widgets {
              type
              config {
                infoItems {
                  contentTypeCode
                  label
                  icon
                }
                overtextContentTypeCode
                fileDisplay
                dense
                numberFormats {
                  contentTypeCode
                  style
                  currency
                  minimumFractionDigits
                  maximumFractionDigits
                  useGrouping
                }
                viewMode
                maxItems
                icon
                title
                showIcon
                showLabel
                showSeparator
                imageStyle {
                  width
                  height
                  maxWidth
                  maxHeight
                  objectFit
                  borderRadius
                }
                displayContentTypes
                contentTypeGroups
                hideTopBar
                hideCode
                hideBackButton
                hideBottomBar
                hideContentTypeGroupHeaders
                showAddButton
                imageContentType
                cardVariant
                showSearch
                direction
                cardWidth
                cardHeight
                rowGap
                stretchCards
                columnGap
                cardBgColor
                cardTextColor
                mergeTitle
                typeContentType
                sort {
                  field
                  order
                }
                loadMore
                showNewButton
                autoOpenSingleResult
                linkContentTypeCode
                linkPath
                linkedByHierarchyId
                hierarchyId
                hierarchyIds
                displayMode
                fullWidth
                actions {
                  type
                  contentTypeGroups
                  iconOnly
                  templateIds
                }
                itemAction {
                  type
                }
                detailPage {
                  slug
                  linkContentType
                }
                showHeading
                backButtonLabel
                backLink
                headingContentTypeCode
                position
                sticky
                roles
                width
                margin {
                  x
                  y
                  t
                  b
                  l
                  r
                }
                padding {
                  x
                  y
                  t
                  b
                  l
                  r
                }
                bgColor
                textColor
                maxHeight
                showViewAll
                backgroundColor
                showTitle
                titleContentTypeCode
                titleStyle
                chartType
                dimensionContentType {
                  contentTypeGroup
                  contentType
                }
                measureContentType {
                  contentTypeGroup
                  contentType
                }
                chartFilters {
                  field
                  operator
                  value
                }
                colorScheme
                legendPosition
                clickAction {
                  type
                  path
                }
                cellIcon
                exportEnabled
                linkDepth
                contentSource
                rows {
                  hierarchyId
                  label
                  depthRange
                  includeDisabled
                  labelProperty
                }
                columns {
                  hierarchyId
                  label
                  depthRange
                  includeDisabled
                  labelProperty
                }
                cards {
                  title
                  icon
                  image
                  link
                  openInNewTab
                  bgColor
                  textColor
                }
                text
                buttons {
                  label
                  link
                  openInNewTab
                  variant
                  color
                  fullWidth
                }
                columnsPerRow
                rootNodeId
                countedFields {
                  contentTypeGroup
                  contentType
                }
                languages
                channelCodes
                channelCode
                pageSize
              }
            }
          }
        }
      }
      detailLayout {
        columns {
          width
          keepWidgetSlots
          widgets {
            type
            config {
              infoItems {
                contentTypeCode
                label
                icon
              }
              overtextContentTypeCode
              fileDisplay
              dense
              numberFormats {
                contentTypeCode
                style
                currency
                minimumFractionDigits
                maximumFractionDigits
                useGrouping
              }
              viewMode
              maxItems
              icon
              title
              showIcon
              showLabel
              showSeparator
              imageStyle {
                width
                height
                maxWidth
                maxHeight
                objectFit
                borderRadius
              }
              displayContentTypes
              contentTypeGroups
              hideTopBar
              hideCode
              hideBackButton
              hideBottomBar
              hideContentTypeGroupHeaders
              showAddButton
              imageContentType
              cardVariant
              showSearch
              direction
              cardWidth
              cardHeight
              rowGap
              stretchCards
              columnGap
              cardBgColor
              cardTextColor
              mergeTitle
              typeContentType
              sort {
                field
                order
              }
              loadMore
              showNewButton
              autoOpenSingleResult
              linkContentTypeCode
              linkPath
              linkedByHierarchyId
              hierarchyId
              hierarchyIds
              displayMode
              fullWidth
              actions {
                type
                contentTypeGroups
                iconOnly
                templateIds
              }
              itemAction {
                type
              }
              detailPage {
                slug
                linkContentType
              }
              showHeading
              backButtonLabel
              backLink
              headingContentTypeCode
              position
              sticky
              roles
              width
              margin {
                x
                y
                t
                b
                l
                r
              }
              padding {
                x
                y
                t
                b
                l
                r
              }
              bgColor
              textColor
              maxHeight
              showViewAll
              backgroundColor
              showTitle
              titleContentTypeCode
              titleStyle
              chartType
              dimensionContentType {
                contentTypeGroup
                contentType
              }
              measureContentType {
                contentTypeGroup
                contentType
              }
              chartFilters {
                field
                operator
                value
              }
              colorScheme
              legendPosition
              clickAction {
                type
                path
              }
              cellIcon
              exportEnabled
              linkDepth
              contentSource
              rows {
                hierarchyId
                label
                depthRange
                includeDisabled
                labelProperty
              }
              columns {
                hierarchyId
                label
                depthRange
                includeDisabled
                labelProperty
              }
              cards {
                title
                icon
                image
                link
                openInNewTab
                bgColor
                textColor
              }
              text
              buttons {
                label
                link
                openInNewTab
                variant
                color
                fullWidth
              }
              columnsPerRow
              rootNodeId
              countedFields {
                contentTypeGroup
                contentType
              }
              languages
              channelCodes
              channelCode
              pageSize
              eventType
              limit
              periodDays
              bucket
            }
          }
          tabs {
            id
            label
            icon
            widgets {
              type
              config {
                infoItems {
                  contentTypeCode
                  label
                  icon
                }
                overtextContentTypeCode
                fileDisplay
                dense
                numberFormats {
                  contentTypeCode
                  style
                  currency
                  minimumFractionDigits
                  maximumFractionDigits
                  useGrouping
                }
                viewMode
                maxItems
                icon
                title
                showIcon
                showLabel
                showSeparator
                imageStyle {
                  width
                  height
                  maxWidth
                  maxHeight
                  objectFit
                  borderRadius
                }
                displayContentTypes
                contentTypeGroups
                hideTopBar
                hideCode
                hideBackButton
                hideBottomBar
                hideContentTypeGroupHeaders
                showAddButton
                imageContentType
                cardVariant
                showSearch
                direction
                cardWidth
                cardHeight
                rowGap
                stretchCards
                columnGap
                cardBgColor
                cardTextColor
                mergeTitle
                typeContentType
                sort {
                  field
                  order
                }
                loadMore
                showNewButton
                autoOpenSingleResult
                linkContentTypeCode
                linkPath
                linkedByHierarchyId
                hierarchyId
                hierarchyIds
                displayMode
                fullWidth
                actions {
                  type
                  contentTypeGroups
                  iconOnly
                  templateIds
                }
                itemAction {
                  type
                }
                detailPage {
                  slug
                  linkContentType
                }
                showHeading
                backButtonLabel
                backLink
                headingContentTypeCode
                position
                sticky
                roles
                width
                margin {
                  x
                  y
                  t
                  b
                  l
                  r
                }
                padding {
                  x
                  y
                  t
                  b
                  l
                  r
                }
                bgColor
                textColor
                maxHeight
                showViewAll
                backgroundColor
                showTitle
                titleContentTypeCode
                titleStyle
                chartType
                dimensionContentType {
                  contentTypeGroup
                  contentType
                }
                measureContentType {
                  contentTypeGroup
                  contentType
                }
                chartFilters {
                  field
                  operator
                  value
                }
                colorScheme
                legendPosition
                clickAction {
                  type
                  path
                }
                cellIcon
                exportEnabled
                linkDepth
                contentSource
                rows {
                  hierarchyId
                  label
                  depthRange
                  includeDisabled
                  labelProperty
                }
                columns {
                  hierarchyId
                  label
                  depthRange
                  includeDisabled
                  labelProperty
                }
                cards {
                  title
                  icon
                  image
                  link
                  openInNewTab
                  bgColor
                  textColor
                }
                text
                buttons {
                  label
                  link
                  openInNewTab
                  variant
                  color
                  fullWidth
                }
                columnsPerRow
                rootNodeId
                countedFields {
                  contentTypeGroup
                  contentType
                }
                languages
                channelCodes
                channelCode
                pageSize
              }
            }
          }
        }
      }
    }
    defaultPageUri {
      uri
      roleOverrides {
        role
        uri
      }
    }
    hierarchiesPageRoles
    fiammSettings {
      balanceGoalsHierarchyId
      pattuizioniHierarchyId
    }
    jobList
    jsonataDependenciesEnabled
    enableExternalCallLog
    enableUserAnalytics
    enableFindReplace
    enableBulkChangeRules
    enableInheritFromParent
    enableLinkTo
    variantPricingEnabled
    publishedContentSourceEnabled
    enableSearchCellEditing
    globalSearch {
      hierarchyIds
      resultsPerGroup
      showPhasedOut
      groupLabels {
        hierarchyId
        label
      }
    }
    hasFieldEncryptionKey
    userManagement {
      hierarchyId
      dealershipHierarchyId
    }
    media {
      enable
      hierarchyId
    }
    hiddenNodeActions
    nodeActionsPlacement
    appBar
    createHierarchyRoles
    channels {
      code
      label
      locales
      schemaCodes
    }
  }
}
    `;

/**
 * __useSettingsQuery__
 *
 * To run a query within a React component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsQuery(baseOptions?: Apollo.QueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
      }
export function useSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsQuery, SettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsQuery, SettingsQueryVariables>(SettingsDocument, options);
        }
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>;
export type SettingsLazyQueryHookResult = ReturnType<typeof useSettingsLazyQuery>;
export type SettingsQueryResult = Apollo.QueryResult<SettingsQuery, SettingsQueryVariables>;